// extracted by mini-css-extract-plugin
module.exports = {"heroRootContainer":"Hero_heroRootContainer__3B3t5","tagContainer":"Hero_tagContainer__1izW2","descriptionContainer":"Hero_descriptionContainer__wg4mh"};